// components/Core/Dashboard/TopClicked.jsx
import { useEffect, useState, useMemo } from "react";
import { Paper, Box, Typography, Chip, LinearProgress } from "@mui/material";

const API_BASE = (process.env.REACT_APP_ADMIN_API || "").trim();
const KEY = (process.env.REACT_APP_ADMIN_KEY || "").trim();

export default function TopClicked({ venues = [], hours = 6, limit = 10 }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const nameByIdent = useMemo(() => {
    const m = new Map();
    for (const v of venues) {
      const ident = v.slug || v.internallink || v.id;
      m.set(String(ident), v.venue_name || ident);
    }
    return m;
  }, [venues]);

  useEffect(() => {
    let alive = true;
    const fetchIt = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE}/api/admin/analytics/top-clicked?hours=${hours}&limit=${limit}`, {
          headers: { "x-admin-key": KEY },
        });
        const json = await res.json();
        if (alive) setData(json);
      } catch (error) {
        console.error('[TopClicked] Failed to fetch:', error);
      } finally {
        if (alive) setLoading(false);
      }
    };
    fetchIt();
    const t = setInterval(fetchIt, 30000); // refresh every 30s
    return () => { alive = false; clearInterval(t); };
  }, [hours, limit]);

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6">Top clicked (last {hours}h)</Typography>
      {loading && <LinearProgress sx={{ my: 1 }} />}
      {!data || data.top?.length === 0 ? (
        <Typography variant="body2" sx={{ mt: 1, opacity: 0.7 }}>No clicks yet.</Typography>
      ) : (
        <Box sx={{ mt: 1, display: "grid", gap: 1 }}>
          {data.top.map((r, i) => (
            <Box key={r.ident} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="body2">
                {i + 1}. {nameByIdent.get(String(r.ident)) || r.ident}
              </Typography>
              <Chip label={r.count} size="small" />
            </Box>
          ))}
        </Box>
      )}
    </Paper>
  );
}
